/*eslint-disable */

import Multiselect from 'vue-multiselect'
import {
  VueEditor
} from "vue2-editor";
import axios from 'axios';
import {
  bus
} from '@/main';
import percentageLoader from "@/components/percentage-loader-f-file";
import root from '@/_helpers/roots';
import toast from '@/services/toast';
import userAgreement from '@/components/user-agreement-for-algo-data/index.vue';

let dataUploadApiUrl = root.algoDataApiUrl.link;

var $ = window.jQuery = require('jquery');
export default {
  name: 'create-algo-data-details',
  components: {
    VueEditor,
    'user-agreement-popup': userAgreement,
    percentageLoader,
    Multiselect
  },
  props: [],
  data() {
    return {
      userAgreementStatePopup: true,
      categoryData: ['Allogenic Stem Cell Transplant',
        'Aplastic Anemia',
        'Autologous Stem Cell Transplant',
        'Bladder Cancer',
        'Bone Cancer',
        'Breast Cancer',
        'Cancer Drugs',
        'Cervical Cancer',
        'Clinical Oncology',
        'Colon Cancer',
        'Colorectal Cancer',
        'Cytology',
        'Drug Research',
        'Endometrial cancer',
        'Esophageal Cancer',
        'Gastrointestinal Cancer',
        'Glioblastoma',
        'Gynaecological Cancer',
        'Head and Neck Cancer',
        'Immunotherapy',
        'Kidney Cancer',
        'Leukemia',
        'Lung Cancer',
        'Lymphoma',
        'Medical Physics',
        'Melanoma',
        'Multiple Myeloma',
        'Nuclear Medicine',
        'Ovarian Cancer',
        'Pancreatic Cancer',
        'Pathology',
        'Prostrate Cancer',
        'Radiology',
        'Radiotherapy',
        'Retinoblastoma',
        'Sarcoma',
        'Testicular Cancer'
      ],
      submitted: false,
      title: '',
      comment: '',
      is_publish: false,
      category: '',
      file: null,
      uploadAttachmentName: '',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData: '',
      uploadProgress: 0,
      shareDataset: false,
      userList: null,
      userListResults: [],
      options: [],
      users: [],
      sentUserData:[]
    }
  },
  computed: {

  },
  mounted() {
    this.getAllUserListMethod()
    bus.$on('userAgreementStatePopupBus', (data) => {
      this.userAgreementStatePopup = data;
    });
  },
  methods: {
    algoDataPublishedToggle() {
      if (this.is_publish === false) {
        this.is_publish = true
      } else {
        this.is_publish = false
      }
    },
    customLabel({
      email,
      first_name,
      last_name
    }) {
      return `${first_name} ${last_name} - ${email}`
    },
    getAllUserListMethod() {
      this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
        this.userList = res.data.data
        if (this.userList) {
          this.userListResults = this.userList
          for (var i = 0; i < this.userListResults.length; i++) {
            this.options.push({
              first_name: this.userListResults[i].first_name,
              last_name: this.userListResults[i].last_name,
              email: this.userListResults[i].email,
              id: this.userListResults[i].id
            })
          }
        }
      }).catch((err) => {})
    },
    getAlgoDataListAgainMethod() {
      this.$store.dispatch('getAllPubAlgoDataListAction')
      this.$store.dispatch('getAlgoDataListAction')
    },
    selectedCategoryFun(val) {
      this.category = val
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      } else {
        this.uploadAttachmentName = '';
      }
    },
    cancelUploadingFileFun() {
      this.file = null
      this.files = null
      this.uploadAttachmentName = '';
    },
    createAlgoDataBeforeSubmitMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          var formData = new FormData();
          formData.append('header', this.title);
          formData.append('category', this.category);
          formData.append('data_file', this.file);
          formData.append('data_file_name', this.uploadAttachmentName);
          formData.append('is_public', this.is_publish);
          if (this.comment != '') {
            formData.append('data', this.comment);
          }
          axios.post(dataUploadApiUrl, formData, {
            onUploadProgress: progressEvent => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
            },
          }).then((res) => {
            if (this.shareDataset) {
              for (var i = 0; i < this.users.length; i++) {
                this.sentUserData.push(this.users[i].id)
              }
              var payloadDataset = {
                algo_data: res.data.data.id,
                user: this.sentUserData,
              }
              this.$store.dispatch('shareDatasetAction', payloadDataset)
                .then((res) => {
                  toast.success("Request processed successfully.");
                  this.submitted = false
                  this.uploadProgress = 0
                  this.closeCreateAlgoDataPopup()
                }).catch((err) => {
                  toast.error(err.data.message || "Request failed.");
                  this.submitted = false
                })
            } else {
              toast.success(res.data.msg);
              this.submitted = false
              this.uploadProgress = 0
              this.closeCreateAlgoDataPopup()
            }
          }).catch((err) => {
            this.submitted = false
            toast.error(err.data.user_msg || err.data.msg);
          })
          return;
        }
      })
    },
    closeCreateAlgoDataPopup() {
      bus.$emit('createAlgoDataPopupBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  }
}